import React from 'react';

interface PricingCardProps {
  title: string;
  duration: string;
  price: string;
  priceUnit: string;
  features: string[];
  isPopular?: boolean;
  buttonText?: string;
}

const PricingCard: React.FC<PricingCardProps> = ({ 
  title, 
  duration, 
  price, 
  priceUnit,
  features, 
  isPopular = false,
  buttonText = "BOOK NOW"
}) => {
  return (
    <div className={`relative rounded-lg p-8 ${isPopular ? 'bg-primary-gold' : 'bg-primary-black border border-primary-gold'}`}>
      {isPopular && (
        <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
          <span className="bg-primary-black text-primary-gold px-4 py-1 rounded-full text-xs font-semibold uppercase tracking-wider">
            Most Popular
          </span>
        </div>
      )}
      
      <div className="mb-6">
        <h3 className={`text-2xl font-bold mb-2 font-display ${isPopular ? 'text-primary-black' : 'text-white'}`}>
          {title}
        </h3>
        <p className={`text-sm ${isPopular ? 'text-gray-800' : 'text-gray-400'}`}>
          {duration}
        </p>
      </div>

      <div className="mb-6">
        <div className="flex items-baseline">
          <span className={`text-5xl font-bold font-display ${isPopular ? 'text-primary-black' : 'text-primary-gold'}`}>
            {price}
          </span>
          <span className={`ml-2 text-sm ${isPopular ? 'text-gray-800' : 'text-gray-400'}`}>
            {priceUnit}
          </span>
        </div>
      </div>

      <ul className="space-y-3 mb-8">
        {features.map((feature, index) => (
          <li key={index} className="flex items-start">
            <span className={`mr-3 ${isPopular ? 'text-primary-black' : 'text-primary-gold'}`}>✓</span>
            <span className={`text-sm ${isPopular ? 'text-gray-800' : 'text-gray-300'}`}>
              {feature}
            </span>
          </li>
        ))}
      </ul>

      <button className={`w-full py-3 rounded-md font-semibold transition-colors ${
        isPopular 
          ? 'bg-primary-black text-primary-gold hover:bg-gray-900' 
          : 'bg-transparent border-2 border-primary-gold text-primary-gold hover:bg-primary-gold hover:text-primary-black'
      }`}>
        {buttonText}
      </button>
    </div>
  );
};

export default PricingCard;
